import { noop, checkIfIOSDevice, safeGet } from "src/shared/utils";

export class OrientationService {
  private orientationChangeEventHandler: () => void;

  public constructor() {
    this.orientationChangeEventHandler = noop;
  }

  public getDimensions() {
    return {
      siteHeight: window.outerHeight,
      siteWidth: window.outerWidth,
    };
  }

  public init() {
    this.handleRootStyling(!this.checkIfPortraitMode());
  }

  /**Get the device type to attach events Listereners for android and ios respectively */
  private getOrientationAngle() {
    return checkIfIOSDevice()
      ? Number(safeGet(window, "orientation", 0))
      : Number(safeGet(window, "screen.orientation.angle", 0));
  }

  public checkIfPortraitMode() {
    return this.getOrientationAngle() === 0;
  }

  private handleRootStyling(isLandscapeMode: boolean) {
    /** hack to disable overflow of the app when in landscape mode since
     * the device width and height doesnt swap on orientation change
     */
    if (isLandscapeMode) {
      document.body.style["overflow-y"] = "hidden";
      const rootElement = document.getElementById("root");
      rootElement ? (rootElement.style.height = "100%") : null;
    } else {
      document.body.style["overflow"] = "auto";
    }
  }

  public addOrientationChangeEventListener(fn: (isPortraitMode: boolean) => void) {
    /**event listeners based on  device type*/
    this.orientationChangeEventHandler = () => {
      const orientationAngle = this.getOrientationAngle();
      this.handleRootStyling(!this.checkIfPortraitMode());

      fn && fn(orientationAngle === 0);
    };

    window.addEventListener("orientationchange", this.orientationChangeEventHandler);
  }

  public removeOrientationChangeEventListener() {
    window.removeEventListener("orientationchange", this.orientationChangeEventHandler);
  }
}

export default new OrientationService();
